<template>
  <div class="full-screen">
    <!-- scroll -->
    <div
      class="overlay-card visible 0:10 full-screen d-flex justify-center align-center"
    >
      <span class="text-h3 font-weight-thin grey--text">
        Scroll to progress
      </span>
    </div>

    <!-- intro logo -->
    <div
      class="overlay-card hidden 20:800 full-screen d-flex justify-center align-center"
    >
      <div>
        <img
          src="imgs/logo/gs-logo-circle.png"
          style="width: 18rem; height: 18rem"
          class="soft-shadow"
        />
      </div>
      <div>
        <span
          class="text-h1 font-weight-bold"
          style="color: var(--color-asphalt)"
        >
          GreenShade
        </span>
        <p class="text-h2 font-weight-thin grey--text">
          Helping you upcycle your business
        </p>
      </div>
    </div>

    <!-- green card desc -->
    <div
      class="overlay-card hidden 820:1200 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <div>
          <img
            src="imgs/logo/gs-logo-circle.png"
            style="width: 10rem; height: 10rem"
            class="soft-shadow"
          />
        </div>
        <v-card
          color="primary"
          width="40rem"
          class="text-center text-h3 font-weight-light pa-12 white--text"
        >
          GreenShade
          <br />
          is a tool that
          <br />
          helps you spot
          <br />
          <b>cradle-to-cradle</b>
          <br />resource loop opportunities <br />in your business cycle
        </v-card>
      </div>
    </div>

    <!-- add monday board -->
    <div
      class="overlay-card hidden 1210:1500 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
          Add your inventory to a monday.com board
        </v-card>
        <div>
          <img
            src="imgs/screenshots/monday-board-inventory.png"
            style="height: 40rem"
            class="soft-shadow"
          />
        </div>
      </div>
    </div>

    <!-- set the date you plan to retire them -->
    <div
      class="overlay-card hidden 1510:1800 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
          Set the date you plan to retire them
        </v-card>
        <v-card outlined>
          <img
            src="imgs/screenshots/monday-retire-date.png"
            style="height: 30rem"
          />
        </v-card>
      </div>
    </div>

    <!-- items-popping-in video -->
    <div
      class="overlay-card hidden 1810:2100 full-screen d-flex justify-center align-center play-video_vid-items-popping-in"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
          Add the GreenShade view to your board
          <br />
          and see it do the magic
        </v-card>
        <v-card flat>
          <video preload autobuffer loop muted style="height: 30rem">
            <source type="video/mp4" src="vids/snippets/items-popping-in.mp4" />
          </video>
        </v-card>
      </div>
    </div>

    <!-- sample-graph -->
    <div
      class="overlay-card hidden 2110:2400 full-screen d-flex justify-center align-center sample-graph"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        See what good things your "waste" can turn into
        </v-card>
        <v-card outlined>
          <img
            src="imgs/screenshots/monday-sample-graph.png"
            style="height: 40rem"
          />
        </v-card>
      </div>
    </div>

    <!-- pools-of-resources -->
    <div
      class="overlay-card hidden 2410:2700 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Which collect over time and become available as resources for your local community
        </v-card>
        <v-card outlined>
          <img
            src="imgs/screenshots/monday-board-stats-pane.png"
            style="height: 40rem"
          />
        </v-card>
      </div>
    </div>

    <!-- shared-dashboards -->
    <div
      class="overlay-card hidden 2710:3000 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Create shared dashboards to see how much resources you can pool with others
        </v-card>
        <v-card outlined>
          <img
            src="imgs/screenshots/monday-sample-dashboard.png"
            style="height: 40rem"
          />
        </v-card>
      </div>
    </div>

    <!-- measure-and-track video -->
    <div
      class="overlay-card skip hidden 3010:3300 full-screen d-flex justify-center align-center play-video_vid-measure-and-track"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Measure and track how much you save in the process
        </v-card>
        <v-card outlined>
          <img
            src="imgs/screenshots/monday-info-pane.png"
            style="height: 40rem"
          />
        </v-card>
      </div>
    </div>

    <!-- monday-board-demo video -->
    <div
      class="overlay-card hidden 3310:3600 full-screen d-flex justify-center align-center play-video_vid-measure-and-quantify"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Demo
        </v-card>
        <v-card outlined>
          <video preload autobuffer loop muted style="height: 40rem">
            <source type="video/mp4" src="vids/recordings/monday-board.mp4" />
          </video>
        </v-card>
      </div>
    </div>

    <!-- learn-more -->
    <div
      class="overlay-card hidden 3610:3900 full-screen d-flex flex-column justify-center align-center"
    >
      <v-card outlined>
        <p class="text-h4 font-weight-light font-style-italic">
          Full Walkthrough
        </p>
        <video preload autobuffer loop muted style="width: 20rem">
          <source type="video/mp4" src="vids/full-walkthrough.mp4" />
        </video>
      </v-card>
      <br /><br />
      <p class="text-h2 font-weight-thin grey--text">
        Learn more
      </p>
      <p class="text-h5 font-weight-thin grey--text">
        See all features, learn how to use and explore demos at links below
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/demo-board" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/demo-board
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/demo-dashboard" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/demo-dashboard
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/features" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/features
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="https://github.com/amitlzkpa/green-shade" target="_blank" class="text-decoration-none blue--text">
          github.com/amitlzkpa/green-shade
        </a>
      </p>
      <v-divider width="10rem" class="my-4" />
      <p class="text-h5 font-weight-light">
        <a href="/vids/full-walkthrough.mp4" target="_blank" class="text-decoration-none grey--text">
          green-shade.web.app/vids/full-walkthrough.mp4
        </a>
      </p>
    </div>

    <!-- try it out -->
    <div
      class="overlay-card hidden 3910:4200 full-screen d-flex flex-column justify-center align-center"
    >
      <div>
        <img
          src="imgs/logo/gs-logo-circle.png"
          style="width: 9rem; height: 9rem"
          class="soft-shadow"
        />
      </div>
      <p
        class="text-h1 font-weight-bold"
        style="color: var(--color-asphalt)"
      >
        GreenShade
      </p>
      <br /><br />
      <p class="text-h4 font-weight-thin grey--text">
        Try it out
      </p>
      <p class="text-h2 font-weight-thin">
        <a href="/" class="text-decoration-none blue--text">
          green-shade.web.app
        </a>
      </p>
      <div>
        <a href="https://auth.monday.com/oauth2/authorize?client_id=e31c39b6065da96a67efa1da68b8df1d&response_type=install" target="_blank">
          <img
            src="imgs/logo/monday.png"
            style="height: 3rem"
          />
        </a>
      </div>
      <p class="text-h4 font-weight-light">
        <a href="/demo-board" target="_blank" class="text-decoration-none grey--text">
          green-shade.web.app/demo-board
        </a>
      </p>
      <p class="text-h4 font-weight-light">
        <a href="/demo-dashboard" target="_blank" class="text-decoration-none grey--text">
          green-shade.web.app/demo-dashboard
        </a>
      </p>
    </div>
  </div>
</template>

<script>

// -- videos deps:[timestamps]

// pauses video if computed style has visibility !== hidden
function setupVidPlayPauser() {
  let videos = document.getElementsByTagName("video");
  window.addEventListener("wheel", () => {
    for (let i = 0; i < videos.length; i++) {
      let video = videos[i];
      let shouldPause = window.getComputedStyle(video).visibility === "hidden";
      if (shouldPause) {
        video.pause();
      } else {
        video.play();
      }
    }
  });
  
}

// -- timestamps

let maxVal = 4000;
let startVal = 0;
let moveSpeed = 10;
let currentVal = startVal;

let scaleMoveAmt = 1;
let scaleTime = 1;
scaleTime = 0.5;

let moveAmt;

function updateCardStates() {
  let overlayCards = document.querySelectorAll("[class*=overlay-card]");
  overlayCards.forEach((node) => {
    let timeStamp = [...node.classList].filter((cl) => cl.includes(":"))[0];
    let isSkipped = node.classList.contains("skip");
    if (!timeStamp) return;
    let stVal = timeStamp.split(":")[0] * scaleTime;
    let edVal = timeStamp.split(":")[1] * scaleTime;
    let isInTimeWindow = stVal <= currentVal && currentVal < edVal;
    if (isInTimeWindow && !isSkipped) {
      node.classList.add("visible");
      node.classList.remove("hidden");
    } else {
      node.classList.remove("visible");
      node.classList.add("hidden");
    }
  });
}

function setupScrollReader() {

window.addEventListener("keydown", (event) => {
  if (event.key !== "ArrowDown") return;
  moveAmt = moveSpeed * scaleMoveAmt * 3;
  if (currentVal + moveAmt <= 0) {
    currentVal = 0;
    moveAmt = 0;
  } else if (currentVal + moveAmt >= maxVal) {
    currentVal = maxVal;
    moveAmt = 0;
  } else {
    currentVal += moveAmt;
  }

  // console.log(`${moveAmt}\t\t${currentVal}`);

  updateCardStates();
});

  window.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowUp") return;
    moveAmt = moveSpeed * scaleMoveAmt * 3 * -1;
    if (currentVal + moveAmt <= 0) {
      currentVal = 0;
      moveAmt = 0;
    } else if (currentVal + moveAmt >= maxVal) {
      currentVal = maxVal;
      moveAmt = 0;
    } else {
      currentVal += moveAmt;
    }

    // console.log(`${moveAmt}\t\t${currentVal}`);

    updateCardStates();
  });

  window.addEventListener("wheel", (event) => {
    moveAmt = moveSpeed * (event.deltaY < 0 ? -1 : 1) * scaleMoveAmt;
    if (currentVal + moveAmt <= 0) {
      currentVal = 0;
      moveAmt = 0;
    } else if (currentVal + moveAmt >= maxVal) {
      currentVal = maxVal;
      moveAmt = 0;
    } else {
      currentVal += moveAmt;
    }

    // console.log(`${moveAmt}\t\t${currentVal}`);

    updateCardStates();
  });
}

export default {
  async mounted() {
    setupScrollReader();
    setupVidPlayPauser();
  },
};
</script>

<style scoped>

.overlay-card {
  z-index: 9999;
  position: fixed;
}

</style>